import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import './BundleLevelBar.scss';
import { asyncFilterBundlesByLevel } from 'actions/bundles';

export class BundleLevelBar extends Component {
  static propTypes = {
    level: PropTypes.string.isRequired,
    filterByLevel: PropTypes.func
  };

  render() {
    const { className, level, filterByLevel } = this.props;

    return (
      <div className={classNames('level-filter d-flex align-items-center', className)}>
        <button className={classNames({ active: level === 'all' })} onClick={() => filterByLevel('all')}>
          All
        </button>
        <button className={classNames({ active: level === 'premium' })} onClick={() => filterByLevel('premium')}>
          Premium
        </button>
        <button className={classNames({ active: level === 'standard' })} onClick={() => filterByLevel('standard')}>
          Standard
        </button>
        <div className="selector" />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  level: state.bundles.level
});

const mapDispatchToProps = dispatch => ({
  filterByLevel: level => dispatch(asyncFilterBundlesByLevel(level))
});

export default connect(mapStateToProps, mapDispatchToProps)(BundleLevelBar);
